import React, { ReactElement, ReactNode } from 'react';

import { Box, Typography, Skeleton } from '@mui/material';
import Icon, { SizeVariant } from '@apigrowfinance/pbolt-icon';
import { CustomTheme, useTheme } from '@apigrowfinance/pbolt-theme-provider';

interface LimitTileProps {
    icon: ReactNode;
    value: ReactNode;
    title: ReactNode;
    isLoading?: boolean;
}

const LimitTile = ({ icon, value, title, isLoading }: LimitTileProps) => {
    const { theme } = useTheme();
    return (
        <Box
            data-testid="limit-tile"
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                flex: '1 1 0',
                textAlign: 'center',
                my: 1,
            }}>
            <Box sx={{ mb: theme.spacing(2.625), mt: theme.spacing(1.5) }}>
                <Icon sizeVariant={SizeVariant.Medium}>
                    {icon as ReactElement}
                </Icon>
            </Box>
            <Typography textAlign="center">{title}</Typography>
            <Typography
                variant="h3"
                textAlign="center"
                sx={(theme: CustomTheme) => ({
                    color: theme.custom.brand.textMain,
                    fontWeight: 600,
                })}>
                {isLoading ? (
                    <Skeleton width={120} data-testid="value-skeleton" />
                ) : (
                    value
                )}
            </Typography>
        </Box>
    );
};

export default LimitTile;
